import { render, staticRenderFns } from "./TagDictionaryEntriesModal.vue?vue&type=template&id=35b7ddfe&scoped=true"
import script from "./TagDictionaryEntriesModal.vue?vue&type=script&lang=js"
export * from "./TagDictionaryEntriesModal.vue?vue&type=script&lang=js"
import style0 from "./TagDictionaryEntriesModal.vue?vue&type=style&index=0&id=35b7ddfe&prod&lang=css"
import style1 from "./TagDictionaryEntriesModal.vue?vue&type=style&index=1&id=35b7ddfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7ddfe",
  null
  
)

export default component.exports